import React from 'react'
import PropTypes from 'prop-types'
import ContactComponent from './ContactComponent'
import SubscriptionComponent from './SubscriptionComponent'

class ProfileInfoComponent extends React.PureComponent {
  render () {
    const {
      contact,
      subscription,
      originalSubscription,
      editing,
      toggleEditMode,
      saveContact,
      updateContact,
      resetContact,
      requestEmailEdit,
      profileInfoChanged,
      updates,
      setSubscriptionToDefault,
      toggleContactStatus,
      toggleProductStatus,
      toggleRegionStatus,
      saveSubscription,
      saveDeactivate,
      manageEmailsView
    } = this.props

    return (
      <React.Fragment>
        {manageEmailsView
          ? null
          : <ContactComponent
            contact={contact}
            editing={editing}
            toggleEditMode={toggleEditMode}
            saveContact={saveContact}
            updateContact={updateContact}
            resetContact={resetContact}
            requestEmailEdit={requestEmailEdit}
            profileInfoChanged={profileInfoChanged}
          />
        }
        <SubscriptionComponent
          contact={contact}
          subscription={subscription}
          originalSubscription={originalSubscription}
          updates={updates}
          setSubscriptionToDefault={setSubscriptionToDefault}
          toggleContactStatus={toggleContactStatus}
          toggleProductStatus={toggleProductStatus}
          toggleRegionStatus={toggleRegionStatus}
          saveSubscription={saveSubscription}
          saveDeactivate={saveDeactivate}
          manageEmailsView={manageEmailsView}
        />
      </React.Fragment>
    )
  }
}

ProfileInfoComponent.propTypes = {
  contact: PropTypes.object,
  editing: PropTypes.bool,
  toggleEditMode: PropTypes.func,
  saveContact: PropTypes.func,
  updateContact: PropTypes.func,
  resetContact: PropTypes.func,
  requestEmailEdit: PropTypes.func,
  profileInfoChanged: PropTypes.bool,
  updates: PropTypes.object,
  setSubscriptionToDefault: PropTypes.func,
  toggleContactStatus: PropTypes.func,
  toggleRegionStatus: PropTypes.func,
  saveSubscription: PropTypes.func,
  saveDeactivate: PropTypes.func,
  manageEmailsView: PropTypes.bool
}

export default ProfileInfoComponent
